import { useState, useEffect } from 'react';
import { useAuth } from './useSupabase';
import supabase from '../lib/supabase';

/**
 * Hook to get the current admin's role and capabilities
 */
export const useAdminRole = () => {
  const { user } = useAuth();
  const [role, setRole] = useState(null); // 'superadmin', 'admin', 'editor'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRole = async () => {
      if (!user?.email) {
        setRole(null);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('authorized_admins_aox1234')
          .select('role')
          .eq('email', user.email)
          .single();

        if (error) throw error;
        setRole(data?.role || 'editor'); // Default to editor if found but no role set
      } catch (err) {
        console.error('Error fetching admin role:', err);
        setRole('editor'); // Fallback to safest role
      } finally {
        setLoading(false);
      }
    };

    fetchRole();
  }, [user]);

  // Capabilities based on role
  const canDelete = role === 'superadmin' || role === 'admin';
  const canManageUsers = role === 'superadmin';
  const canManageSettings = role === 'superadmin' || role === 'admin';
  const isSuperAdmin = role === 'superadmin';
  const isEditor = role === 'editor';

  return { 
    role, 
    loading, 
    canDelete, 
    canManageUsers, 
    canManageSettings,
    isSuperAdmin,
    isEditor
  };
};